import { Navigate, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectIsLoggedIn } from "../Redux/authSlice";
import { useAuth } from "../context/AuthContext";
import Loader from "../component/Loader/Loader";

const PublicRoute = ({ children }) => {
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const { loading } = useAuth();
  const [searchParams] = useSearchParams();

  // Desktop SSO: when the native app opens /login?client=desktop, always show
  // the login page — even if the browser already has a website session — so the
  // app can complete a fresh login and receive its token. Without this, a
  // logged-in browser would be redirected away from /login.
  const isDesktopLogin = searchParams.get("client") === "desktop";

  if (loading) {
    return <Loader />;
  }

  if (isLoggedIn && !isDesktopLogin) {
    const history = JSON.parse(localStorage.getItem("pathHistory")) || [];
    const secondLastPath =
      history.length > 1 ? history[history.length - 2] : "/";
    return <Navigate to={secondLastPath} replace />;
  }

  return children;
};

export default PublicRoute;
